// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".el-footer[data-v-9406787e]{font-size:13px;text-align:center}", "",{"version":3,"sources":["/home/runner/work/cuona-manager/cuona-manager/src/components/public/Footer.vue"],"names":[],"mappings":"AAiBA,4BACE,cAAA,CACA,iBAAA","file":"Footer.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import \"../../styles/variables.scss\";\n\n.el-footer {\n  font-size: 13px;\n  text-align: center;\n}\n\n"]}]);
// Exports
module.exports = exports;
